import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import routes from '../../routes';
import './MainLayout.scss'
import _ from 'lodash';

/* eslint eqeqeq: 0 */
export class MainLayout extends Component {
  render() {
    const { user } = this.props;
    const filteredRoutes = _.filter(routes, (route) => {
      return true;//user && route.allowedRoles.indexOf(_.first(user.roles)) > -1
    })
    return (
      <div>
      <Switch>
      {
        filteredRoutes.map((route, idx) => {
          return route.component ? (<Route key={idx} path={route.path} exact={route.exact}
            name={route.name}
            render={props => (<route.component {...props} />)} />)
            : '';
        })
      }
    </Switch>
    asdnasfkj
    </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(
  mapStateToProps
)(MainLayout);
